var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"atom-image",style:(_vm.styles),attrs:{"src":_vm.src,"alt":_vm.alt,"loading":_vm.lazy ? 'lazy' : 'eager',"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }